import type { ReactNode } from "react"

import { ComDica } from "./ComDica"
import { ROTULO_DE_CAMPO } from "../lib/classes"
import { cn } from "../lib/cn"

export function MarcaDeObrigatorio() {
  return (
    <ComDica dica="Campo obrigatório" foraDoTab>
      <span data-slot="campo-exigido" aria-hidden="true" className="cursor-default leading-none font-semibold text-(--vermelho)">
        *
      </span>
    </ComDica>
  )
}

export function RotuloDoCampo({
  htmlFor,
  obrigatorio = false,
  children,
}: {
  htmlFor: string
  obrigatorio?: boolean
  children: ReactNode
}) {
  return (
    <div data-slot="rotulo-do-campo" className="mb-1.5 flex h-4 items-center gap-1">
      <label className={cn(ROTULO_DE_CAMPO, "mb-0")} htmlFor={htmlFor}>
        {children}
      </label>
      {obrigatorio && <MarcaDeObrigatorio />}
    </div>
  )
}

export function faltaNoFormulario(pares: [string, string | null | undefined][]): string | null {
  const falta = pares.find(([, valor]) => (valor ?? "").trim() === "")
  return falta === undefined ? null : `Falta ${falta[0]}`
}
